import { render, staticRenderFns } from "./VariablesBuilderBlock.vue?vue&type=template&id=1895892d"
import script from "./VariablesBuilderBlock.vue?vue&type=script&lang=js"
export * from "./VariablesBuilderBlock.vue?vue&type=script&lang=js"
import style0 from "./VariablesBuilderBlock.vue?vue&type=style&index=0&id=1895892d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports